import { render, staticRenderFns } from "./InputBoxplotCustomize.vue?vue&type=template&id=d235f584"
import script from "./InputBoxplotCustomize.vue?vue&type=script&lang=js"
export * from "./InputBoxplotCustomize.vue?vue&type=script&lang=js"
import style0 from "./InputBoxplotCustomize.vue?vue&type=style&index=0&id=d235f584&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports